import { ActionTree } from 'vuex'

import api from '@/apiClient'

import { assertToken } from '@/utils'

import { RootState } from '../state'
import itemGroupsActions from './itemGroups/actions'
import itemsActions from './items/actions'
import optionGroupsActions from './optionGroups/actions'
import optionsActions from './options/actions'
import portionsActions from './portions/actions'

import {
  RESET_ITEM_GROUPS_QUERY_INDEX,
  RESET_LOADED_ALL_ITEM_GROUPS,
  UPDATE_ITEM_GROUPS,
  UPDATE_ITEM_GROUPS_TOTAL
} from './itemGroups/mutations'

import {
  CLEAR_ITEM_GROUPS_ITEMS,
  UPDATE_ITEMS
} from './items/mutations'

import {
  CLEAR_ITEM_GROUPS_OPTION_GROUPS,
  UPDATE_OPTION_GROUPS
} from './optionGroups/mutations'

import {
  CLEAR_OPTION_GROUPS_OPTIONS,
  UPDATE_OPTIONS
} from './options/mutations'

import { MenuState } from './state'

const actions: ActionTree<MenuState, RootState> = {
  ...itemGroupsActions,
  ...itemsActions,
  ...optionGroupsActions,
  ...optionsActions,
  ...portionsActions,

  /**
   * Updates the menu brand.
   *
   * It rejects if the user is not logged in.
   *
   * @param imageFile File to be uploaded.
   */
  async updateBrand ({ rootState, rootGetters }, imageFile: File) {
    const tokenV2 = assertToken(rootState.auth.tokenV2)

    const providerId: number | null = rootGetters['auth/currentProvider']

    if (providerId === null) {
      throw new Error('User is not authenticated')
    }
    const formData = new FormData()

    formData.append('file', imageFile)

    await api.menu.images.updateBrand(tokenV2, formData, providerId)
  },

  /**
   * Clears the MenuState.
   */
  logout ({ commit }) {
    commit(UPDATE_ITEM_GROUPS, [])
    commit(UPDATE_ITEM_GROUPS_TOTAL, 0)
    commit(RESET_LOADED_ALL_ITEM_GROUPS)
    commit(RESET_ITEM_GROUPS_QUERY_INDEX)

    commit(CLEAR_ITEM_GROUPS_ITEMS)
    commit(UPDATE_ITEMS, [])

    commit(CLEAR_ITEM_GROUPS_OPTION_GROUPS)
    commit(UPDATE_OPTION_GROUPS, [])

    commit(CLEAR_OPTION_GROUPS_OPTIONS)
    commit(UPDATE_OPTIONS, [])
  }
}

export default actions
